import {Component} from 'react';
import jwt from "jsonwebtoken";

class FunctionsData {
	
	constructor(props) {
	}

	static getApiUrl(endpoint) {
		return process.env.REACT_APP_BASE_API_URL+`${endpoint}`;
	};

	static getSessionToken() {
		const t = jwt.decode(sessionStorage.tkn);
		if(t !== undefined && t.category === 'vet') {
			return sessionStorage.vTkn;
		}
		if(t !== undefined && t.category === 'staff') {
			return sessionStorage.sTkn;
		}
		return sessionStorage.tkn;
	}
	
	static async getCSRFToken() {
		
		const path = '/api/getCSRFToken';
		const x = await fetch(FunctionsData.getApiUrl(path), {
			method: 'GET',
			headers: {'Content-Type': 'application/json', 'token': sessionStorage.tkn}
		})
			.then((res) => {
				return res.json()
			})
			.then((d) => {
				return (d.data);
			});
		
		return String(x);
	}
	
	static async fetchDataGet(path, setDataFn, loading, loadingFn) {
		// console.log('fetchDataGet', path)
		const tkn = await FunctionsData.getCSRFToken();
		if (loading === true) {
			await fetch(FunctionsData.getApiUrl(path), {
				method: 'GET',
				headers: {
					'token': FunctionsData.getSessionToken(),
					'X-CSRF-Token': tkn.csrf
				}
			})
				.then((res) => {
					if (!res.ok) {
						console.log(path, {...res,error:true});
						setDataFn([]);
						loadingFn(false);
						return false;
					}
					return res.json()
				})
				.then((d) => {
					setDataFn(d.data);
					loadingFn(false);
					console.log(path, d);
				});
		}
	}
	
	static async fetchDataGetNoLoading(path, setDataFn) {
		const tkn = await FunctionsData.getCSRFToken();
		await fetch(FunctionsData.getApiUrl(path), {
			method: 'GET',
			headers: {
				'token': FunctionsData.getSessionToken(),
				'X-CSRF-Token': tkn.csrf
			}
		})
			.then((res) => {
				if (!res.ok) {
					setDataFn([]);
					return false;
				}
				return res.json()
			})
			.then((d) => {
				setDataFn(d.data);
				console.log(path, d);
				
			});
	}
	
	static async fetchDataGetNoLoadingReturn(path) {
		
		console.log('fetchDataGetNoLoadingReturn path',path)
		const tkn = await FunctionsData.getCSRFToken();
		
		return await fetch(FunctionsData.getApiUrl(path), {
			method: 'GET',
			headers: {
				'token': FunctionsData.getSessionToken(),
				'X-CSRF-Token': tkn.csrf
			}
		})
			.then((res) =>  res.json())
			.then((d) => {
				console.log('fetchDataGetNoLoadingReturn',path,d)
				return (d.data);
			});
	}
	
	static async fetchDataPost(response, endpoint, sn = '', vet_id = 0, payload = []) {
		const tkn = await FunctionsData.getCSRFToken();
		let path = '/api/search/api_log';
		await fetch(FunctionsData.getApiUrl(path), {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'token': FunctionsData.getSessionToken(),
				'X-CSRF-Token': tkn.csrf
			},
			body: JSON.stringify({
				response: JSON.stringify(response),
				endpoint: endpoint,
				sn: sn,
				vet_id: vet_id,
				payload: JSON.stringify(payload)
			})
		})
			.then((res) => {
				if (!res.ok) {
					return false;
				}
				return res.json()
			})
			.then((d) => {
				//console.log(path, d);
			});
	}
	
	static async fetchDataSingleRow(path, setDataFn) {
		//console.log(path);
		const tkn = await FunctionsData.getCSRFToken();
		await fetch(FunctionsData.getApiUrl(path), {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				'token': FunctionsData.getSessionToken(),
				'X-CSRF-Token': tkn.csrf
			}
		})
			.then((res) => {
				if (!res.ok) {
					setDataFn([]);
					return false;
				}
				return res.json()
			})
			.then((d) => {
				if (d.data.length === 0) {
					setDataFn([]);
				} else {
					setDataFn(d.data[0]);
					//console.log(path, d);
				}
				
			});
	}
	
	static async postData(path, data) {
		const tkn = await FunctionsData.getCSRFToken();
		return await fetch(FunctionsData.getApiUrl(path), {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'token': FunctionsData.getSessionToken(),
				'X-CSRF-Token': tkn.csrf
			},
			body: JSON.stringify(data)
		})
			.then((res) => {
				if (!res.ok) {
					return false;
				}
				return res.json()
			})
			.then((d) => {
				return d;
			});
	}
	
	static async postDataReturn(path, data) {
		const tkn = await FunctionsData.getCSRFToken();
		return await fetch(FunctionsData.getApiUrl(path), {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'token': FunctionsData.getSessionToken(),
				'X-CSRF-Token': tkn.csrf
			},
			body: JSON.stringify(data)
		})
			.then((res) => {
				if (!res.ok) {
					return false;
				}
				return res.json()
			})
			.then((d) => {
				console.log(path, d);
				return d.data;
			});
	}
	
	static async postDataLoading(path, data, loading,setLoading) {
		if(loading === true) {
			const tkn = await FunctionsData.getCSRFToken();
			return await fetch(FunctionsData.getApiUrl(path), {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					'token': FunctionsData.getSessionToken(),
					'X-CSRF-Token': tkn.csrf
				},
				body: JSON.stringify(data)
			})
				.then((res) => {
					if (!res.ok) {
						return false;
					}
					return res.json()
				})
				.then((d) => {
					console.log(path, d);
					setLoading(false);
					return d.data;
				});
		}
	}
}

export default FunctionsData;
